import Image from '../components/Image'
import Video from '../components/Video'

export default src => {
  if(src.indexOf('mp4') > -1) return Video
  return Image
}



/** WEBPACK FOOTER **
 ** ./src/utils/getMedia.js
 **/